import { createContext } from 'react';
import type { PartnerMembershipSummary, PartnerMeResponse } from '../types';

export interface PartnerContextValue {
  /** What the server said about the signed-in user's partner memberships. */
  me: PartnerMeResponse;
  /** The firm the portal is working in: the first Active membership, otherwise the first one. A firm picker is a later step; most people belong to one firm. */
  membership: PartnerMembershipSummary;
  /** Display only: hides what the person's role cannot do. The server authorizes every request regardless. */
  can: (permission: string) => boolean;
  reload: () => Promise<void>;
}

export const PartnerContext = createContext<PartnerContextValue | null>(null);
